module.exports = __webpack_public_path__ + "static/media/Yasuko Hirao.ee1cc8c5.jpg";